// 32 Premium Palette — Onyx zemin üstünde her bir renk parıldıyor
// Her sayfa yenilemede deterministik olmayan random seçim
// CSS variables: --p (primary), --s (secondary/dark), --a (accent/light), --g (glow rgba)

export const PALETTES = [
  { name: "Aurum",      p: "#d4af37", s: "#7a5e0e", a: "#f7e08c", g: "212,175,55" },
  { name: "Rose Gold",  p: "#e0a38a", s: "#7a3f2a", a: "#f5c8b4", g: "224,163,138" },
  { name: "Champagne",  p: "#c9a96e", s: "#6b4f1f", a: "#efd9a8", g: "201,169,110" },
  { name: "Ruby",       p: "#dc2654", s: "#7a0d2a", a: "#ff8aa6", g: "220,38,84" },
  { name: "Sapphire",   p: "#3d6ee3", s: "#1a3a8c", a: "#9bb6f5", g: "61,110,227" },
  { name: "Emerald",    p: "#1ea566", s: "#0a4d2f", a: "#6cd6a3", g: "30,165,102" },
  { name: "Amethyst",   p: "#a855f7", s: "#5b21b6", a: "#d8b4fe", g: "168,85,247" },
  { name: "Topaz",      p: "#f59e0b", s: "#7c4a08", a: "#fcd980", g: "245,158,11" },
  { name: "Garnet",     p: "#b91c1c", s: "#5a0808", a: "#fca5a5", g: "185,28,28" },
  { name: "Aquamarine", p: "#06b6d4", s: "#075985", a: "#7dd3fc", g: "6,182,212" },
  { name: "Onyx Pink",  p: "#ec4899", s: "#7e1d4d", a: "#f9a8d4", g: "236,72,153" },
  { name: "Jade",       p: "#10b981", s: "#0a5740", a: "#6ee7b7", g: "16,185,129" },
  { name: "Coral",      p: "#fb7185", s: "#881337", a: "#fecdd3", g: "251,113,133" },
  { name: "Indigo",     p: "#6366f1", s: "#312080", a: "#a5b4fc", g: "99,102,241" },
  { name: "Citrine",    p: "#eab308", s: "#724b0a", a: "#fde68a", g: "234,179,8" },
  { name: "Tourmaline", p: "#0ea5e9", s: "#075c87", a: "#7dd3fc", g: "14,165,233" },
  { name: "Crimson",    p: "#e11d48", s: "#7d0a25", a: "#fda4af", g: "225,29,72" },
  { name: "Mint",       p: "#22c55e", s: "#0e6e35", a: "#86efac", g: "34,197,94" },
  { name: "Magenta",    p: "#d946ef", s: "#7a1c8c", a: "#f0abfc", g: "217,70,239" },
  { name: "Bronze",     p: "#cd7f32", s: "#5e3a14", a: "#e9b27a", g: "205,127,50" },
  { name: "Lime",       p: "#84cc16", s: "#3a5e0a", a: "#bef264", g: "132,204,22" },
  { name: "Royal Blue", p: "#2563eb", s: "#1e3a8a", a: "#93c5fd", g: "37,99,235" },
  { name: "Plum",       p: "#9333ea", s: "#4a138c", a: "#c4b5fd", g: "147,51,234" },
  { name: "Tangerine",  p: "#f97316", s: "#7a2f08", a: "#fdba74", g: "249,115,22" },
  { name: "Teal",       p: "#14b8a6", s: "#0e6e62", a: "#5eead4", g: "20,184,166" },
  { name: "Fuchsia",    p: "#c026d3", s: "#5e1166", a: "#f5d0fe", g: "192,38,211" },
  { name: "Cyan",       p: "#0891b2", s: "#054957", a: "#a5f3fc", g: "8,145,178" },
  { name: "Salmon",     p: "#fb923c", s: "#7a4108", a: "#fed7aa", g: "251,146,60" },
  { name: "Pearl",      p: "#a3a3a3", s: "#404040", a: "#e5e5e5", g: "163,163,163" },
  { name: "Burgundy",   p: "#9f1239", s: "#4a081d", a: "#f8b7c7", g: "159,18,57" },
  { name: "Forest",     p: "#15803d", s: "#0a3d1c", a: "#86efac", g: "21,128,61" },
  { name: "Ice",        p: "#67e8f9", s: "#155e75", a: "#cffafe", g: "103,232,249" },
];

export function pickRandomPalette(seed) {
  if (typeof seed === "string" && seed.length > 0) {
    let h = 0;
    for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
    h = (h + Math.floor(Date.now() / 1000) * 7) % PALETTES.length;
    return PALETTES[h];
  }
  return PALETTES[Math.floor(Math.random() * PALETTES.length)];
}

export function paletteVars(P) {
  return {
    "--p": P.p,
    "--s": P.s,
    "--a": P.a,
    "--g": P.g,
    "--p-rgba-08": `rgba(${P.g}, 0.08)`,
    "--p-rgba-15": `rgba(${P.g}, 0.15)`,
    "--p-rgba-30": `rgba(${P.g}, 0.30)`,
    "--p-rgba-50": `rgba(${P.g}, 0.50)`,
  };
}
